import React from "react";
import 'Styles/protocolView/clearAllProtocolModal.scss';

const ClearAllProtocolModal = (props) => {
    return (
        <div>
            <b>Внимание!</b> Протокол будет очищен для всех пользователей. Восстановить записи протокола после очистки будет невозможно. Старый протокол будет сохранен на диск.
            <br/>
            <br/>
            Вы действительно хотите очистить протокол событий?
        </div>
    )
}

export default ClearAllProtocolModal;